// angular
// 	.module("HeroPRO")
// 	.factory("ProjectAdvanceFactory", projectAdvanceFactory);

import _ from 'lodash';
/* @ngInject */
export default function projectAdvanceFactory($q, $http, HPConfig) {
    let _projectAdvanceDetailPromise;
    let _activeAdvanceId = {};

    return {
        getProjectAdvanceStatus,
        getProjectAdvanceDetails,
        setActiveProjectAdvanceFundingRequestId,
        getProjectAdvanceDetailsPromise,
    };

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    function getProjectAdvanceStatus(params) {
        return $http.get(`${HPConfig.heroProApi}PEFI/ProjectAdvanceStatus`, {
            params,
        });
    }

    function getProjectAdvanceDetails(params) {
        _projectAdvanceDetailPromise = $q((resolve) => {
            $http.get(`${HPConfig.heroProApi}PEFI/ProjectAdvanceDetails`, {
                params: ((params !== null && params !== undefined) ? params : _activeAdvanceId),
            }).then((response) => {
                resolve(response);
            });
        });

        return _projectAdvanceDetailPromise;
    }

    function getProjectAdvanceDetailsPromise() {
        return _projectAdvanceDetailPromise;
    }

    function setActiveProjectAdvanceFundingRequestId(fundingRequestId) {
        _activeAdvanceId = fundingRequestId;
    }

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */

    /* -----  End of Private Functions  ------*/
}




// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceFactory.js